import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../Context/AppContext";
import VenueTraffic from "./VenueTraffic";
import DashboardRequest from "./DashboardRequest";
import Faqs from "./Faqs";
import NavBar from "../../../components/NavBar";
import "./Dashboard.css";

const DashboardScreen = () => {
  const { userInfo } = useContext(AuthContext);
  const [statsVenues, setstatsVenues] = useState([]);

  useEffect(() => {
    document.title = "Dashboard | Nightspot";
    const fetchData = async () => {
      let request = await DashboardRequest.dashboardInit({});
      if (request && request.status) {
        setstatsVenues(request.statsVenues);
      }
    };
    fetchData();
  }, []);

  return (
    <NavBar>
      <div className="py-4">
        <div className="row">
          <div className="col-12">
            <h1 className="dashboard-greeting">
              Olá, {userInfo.firstName || "Bem-vindo"}! 👋
            </h1>
            <p className="dashboard-subtitle">
              Aqui está o resumo da performance dos teus spots.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8 mb-4">
            <div className="box-dashboard h-100">
              <div className="box-header-dashboard">
                <span>Interações do público</span>
                <i className="fa-solid fa-chart-line text-primary"></i>
              </div>
              <VenueTraffic apiData={statsVenues} />
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="box-dashboard h-100">
              <div className="box-header-dashboard">
                <span>Perguntas Frequentes</span>
                <i className="fa-solid fa-circle-question text-info"></i>
              </div>
              <div className="faq-container">
                <Faqs />
              </div>
            </div>
          </div>
        </div>
      </div>
    </NavBar>
  );
};

export default DashboardScreen;

